import React from "react";

import {
    Form, DatePicker
} from 'antd';

import { RegistComponent, FieldBase } from "easyui-core";
import { WfComponentProps } from "../../WfComponent/WfComponentProps";

export class AntDatetimePick extends React.Component<WfComponentProps> {
    field: FieldBase<any>
    constructor(props) {
        super(props)
        this.field = this.props.field
    }
    handleValueChange = (value) => {

    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null
        return (
            <Form.Item {...formItemLayout} label={this.props.field.label}>
                {getFieldDecorator(this.field.key, {
                    rules: [{
                        validator: this.field.validator
                        // type: this.field.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.field.required, message: '必填项!',
                    }],
                })(
                    <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />
                )}
            </Form.Item>
        )
    }
}
RegistComponent({
    selector: "ef-ant-datepicker",
    component: AntDatetimePick,
    name: "Ant日期时间选择"
})
// export default AntInput